export function widthBetweenLetters(xFn: (index: number) => number, sliceStart: number): number {
  return xFn(sliceStart + 1) - xFn(sliceStart);
}
